import { render, staticRenderFns } from "./ModalMedicinePromo.vue?vue&type=template&id=2d619029&"
import script from "./ModalMedicinePromo.vue?vue&type=script&lang=js&"
export * from "./ModalMedicinePromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports